module.exports = __webpack_public_path__ + "static/media/minato_activec1810d6538854d8e290f6eb566f0444d.webp";